export default "__VITE_ASSET__DzRYEhGu__"